import { FaBars } from "react-icons/fa";
import { navLinks } from "../constants";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from '../assets/logo.jpg';

const Navbar = () => {
    const [toggle, setToggle] = useState(false);
    
    return ( 
       /* <div> 
        <nav className="navbar">
        <img src={logo} alt="logo" />
        </nav>*/
        <nav className="navbar">
            <img src={logo} alt="logo" width="70" height="75" align="center"/>
            <label><span style={{fontFamily: 'Dancing Script',color: '#ab0303'}}>Little Sanctum</span></label>
            <label><span style={{fontFamily: 'Dancing Script',color: '#3CB043'}}>Montessori</span></label>
            <div className="nav-links">
                {navLinks.map(nav => (
                    <NavLink to={nav.link} key={nav.id} className="link">{nav.id}</NavLink>
                ))}
            </div>
            <div className="menu-icons">
                <FaBars 
                    onClick={() => {
                        setToggle(prev => !prev);
                    }}
                />
            </div>
            <div className={`${toggle ? 'show' : 'hidden'}`}>
                {navLinks.map(nav => (
                    <NavLink to={nav.link} key={nav.id} onClick={() => setToggle(false)}>{nav.id}</NavLink>
                ))}
            </div>
        </nav>
      /*  </div> */
    );
}
 
export default Navbar;